<template>
  <div></div>
</template>

<script>
import * as monaco from 'monaco-editor/esm/vs/editor/editor.api'

export default {
  name: 'MonacoWrapper',
  props: {
    language: String,
    value: {
      type: String,
      required: true
    },
    options: {
      type: Object,
      default() {
        return {}
      }
    },
    theme: {
      type: String,
      default: 'vs'
    }
  },
  model: {
    event: 'change'
  },
  data() {
    return {
      editor: null,
      defaultOptions: {
        lineNumbers: 'on',
        autoIndent: 'full',
        tabCompletion: 'on',
        glyphMargin: true,
        theme: this.theme
      },
      modelUri: `${Math.random()
        .toString(36)
        .substring(7)}.json`,
      model: null,
      decorations: [],
      glyphs: []
    }
  },
  watch: {
    options: {
      deep: true,
      handler(options) {
        if (this.editor) {
          this.editor.updateOptions(options)
          this.resetDecorations()
        }
      }
    },
    value(newValue) {
      if (this.editor) {
        if (newValue !== this.editor.getValue()) {
          this.editor.setValue(newValue)
          this.resetDecorations()
        }
      }
    },
    language(newVal) {
      if (this.editor) {
        monaco.editor.setModelLanguage(this.editor.getModel(), newVal)
        this.resetDecorations()
      }
    },
    theme(newVal) {
      if (this.editor) {
        monaco.editor.setTheme(newVal)
        this.resetDecorations()
      }
    }
  },
  mounted() {
    this.parsedUri = monaco.Uri.parse(this.modelUri)
    this.model = monaco.editor.createModel(
      this.value,
      this.language,
      this.parsedUri,
    )

    this.editor = monaco.editor.create(this.$el, this.getOptions(this.model))

    this.editor.onDidChangeModelContent((event) => {
      const value = this.editor.getValue()
      if (this.value !== value) {
        this.$emit('change', value, event)
      }
    })
    this.editor.onMouseDown((e) => this.onMouseDown(e))
    this.$emit('editorMounted', this)
  },
  methods: {
    getOptions(model) {
      return {
        ...this.defaultOptions,
        model,
        ...this.options
      }
    },
    onMouseDown(e) {
      if (e.target.type === 2) {
        const glyph = this.glyphs.find(
          (g) => e.target.position.lineNumber === g.line,
        )
        if (glyph) {
          this.$emit('glyphClicked', glyph)
        }
      }
    },
    setJsonInfo(schemas) {
      schemas[0].fileMatch = [this.parsedUri.toString()]
      monaco.languages.json.jsonDefaults.setDiagnosticsOptions({
        validate: true,
        schemas,
        completionItems: true
      })
    },
    setGlyphs(glyphs) {
      const decorations = glyphs.map((glyph) => ({
        range: new monaco.Range(
          glyph.line,
          glyph.column,
          glyph.line,
          glyph.column,
        ),
        options: {
          isWholeLine: false,
          glyphMarginClassName: 'monaco__MarginGlyph'
        }
      }))
      this.decorations = this.editor.deltaDecorations(this.decorations, decorations)
      this.glyphs = glyphs
    },
    resetDecorations() {
      this.editor.deltaDecorations([], this.decorations)
    }
  },
  beforeDestroy() {
    if (this.editor) {
      this.model.dispose()
      this.editor.dispose()
    }
  }
}
</script>

<style>
.monaco__MarginGlyph {
  background: #0078c1;
  cursor: pointer;
}
</style>
